import { makeStyles } from '@material-ui/core/styles'

const styles = makeStyles(theme => ({
  landscape: {},
  portrait: {},
  sponsors: {
    width: '100%',
    backgroundColor: '#333333',
    flexBasis: 150,
    display: 'flex',
    alignItems: 'center',
    padding: '24px 42px',
    flexGrow: 1,
    '&$portrait': {
      '@media (max-width: 767px)': {
        flexBasis: 'initial',
        height: 73,
        flexShrink: 0,
        flexGrow: 0,
        padding: 16
      }
    },
    '& .BrainhubCarouselItem': {
      padding: theme.spacing(0, 3)
    }
  },
  arrowButton: {
    backgroundColor: '#292929',
    height: 32,
    width: 32,
    fontSize: 12,
    color: 'white',
    padding: 0
  }
}))

export default styles



// WEBPACK FOOTER //
// ./src/components/Sponsors/styles.js